<template>
  <div class="bg-white-900 h-full">
    <div class="px-0 mx-auto relative h-full flex">
      <base-logo class="absolute top-4 left-8" />
      <auth-info class="flex-shrink-0" />
      <auth-message-sent />
    </div>
  </div>
</template>

<script>
import BaseLogo from "@/components/base/BaseLogo.vue";
import AuthInfo from "@/components/auth/AuthInfo.vue";
import AuthMessageSent from "@/components/auth/AuthMessageSent.vue";

export default {
  components: {
    "base-logo": BaseLogo,
    "auth-info": AuthInfo,
    "auth-message-sent": AuthMessageSent,
  },
};
</script>
